import type { SubscribeCampaignConfig } from '../../../config/types';
import SubscribeForm from '../SubscribeForm';
import Header from '../../shared/Header';

interface Props {
  config: SubscribeCampaignConfig;
}

/** "form-old-layout" — pre-redesign column layout, no row-layout-template diagonal cut. */
export default function OldLayoutTemplate({ config }: Props) {
  return (
    <>
      <Header />
      <div className="main-container">
        <div className="form-outer-container">
          <div className="form-bg" id="js-subscribe-form-holder">
            <SubscribeForm config={config} />
          </div>
        </div>
        {config.backgroundImage && (
          <img src={config.backgroundImage} className="background-image full-height cover" alt="" />
        )}
        {config.mobileImage && (
          <img src={config.mobileImage} className="background-image-mobile full-height cover" alt="" />
        )}
      </div>
    </>
  );
}
